/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents sensitive API keys for a business.
 * @export
 * @interface BusinessKeys
 */
export interface BusinessKeys {
    /**
     * 
     * @type {string}
     * @memberof BusinessKeys
     */
    firstDeliveryId?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessKeys
     */
    chowlyApi?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessKeys
     */
    itsaCheckmateAccess?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessKeys
     */
    isPos: boolean;
    /**
     * 
     * @type {string}
     * @memberof BusinessKeys
     */
    stripeAccountId?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessKeys
     */
    uberEatsUUID?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessKeys
     */
    uberEatsUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof BusinessKeys
     */
    oloVendorId?: number;
    /**
     * 
     * @type {string}
     * @memberof BusinessKeys
     */
    oAuthAccess?: string;
}

/**
 * Check if a given object implements the BusinessKeys interface.
 */
export function instanceOfBusinessKeys(value: object): value is BusinessKeys {
    if (!('isPos' in value) || value['isPos'] === undefined) return false;
    return true;
}

export function BusinessKeysFromJSON(json: any): BusinessKeys {
    return BusinessKeysFromJSONTyped(json, false);
}

export function BusinessKeysFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessKeys {
    if (json == null) {
        return json;
    }
    return {
        
        'firstDeliveryId': json['firstDeliveryId'] == null ? undefined : json['firstDeliveryId'],
        'chowlyApi': json['chowlyApi'] == null ? undefined : json['chowlyApi'],
        'itsaCheckmateAccess': json['itsaCheckmateAccess'] == null ? undefined : json['itsaCheckmateAccess'],
        'isPos': json['isPos'],
        'stripeAccountId': json['stripeAccountId'] == null ? undefined : json['stripeAccountId'],
        'uberEatsUUID': json['uberEatsUUID'] == null ? undefined : json['uberEatsUUID'],
        'uberEatsUrl': json['uberEatsUrl'] == null ? undefined : json['uberEatsUrl'],
        'oloVendorId': json['oloVendorId'] == null ? undefined : json['oloVendorId'],
        'oAuthAccess': json['oAuthAccess'] == null ? undefined : json['oAuthAccess'],
    };
}

export function BusinessKeysToJSON(json: any): BusinessKeys {
    return BusinessKeysToJSONTyped(json, false);
}

export function BusinessKeysToJSONTyped(value?: BusinessKeys | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstDeliveryId': value['firstDeliveryId'],
        'chowlyApi': value['chowlyApi'],
        'itsaCheckmateAccess': value['itsaCheckmateAccess'],
        'isPos': value['isPos'],
        'stripeAccountId': value['stripeAccountId'],
        'uberEatsUUID': value['uberEatsUUID'],
        'uberEatsUrl': value['uberEatsUrl'],
        'oloVendorId': value['oloVendorId'],
        'oAuthAccess': value['oAuthAccess'],
    };
}

